import React, { useState } from 'react'
import {
  AccordionItem,
  AccordionHeader,
  Chevron,
  AccordionBody,
  ToggleWrapper,
  ToggleThumb,
  SaveIndicator,
} from './styles'
import { SaveStatus } from './useAutoSave'

export const Toggle = ({
  checked = false,
  onChange,
}: {
  checked?: boolean
  onChange?: (v: boolean) => void
}) => (
  <ToggleWrapper onClick={() => onChange?.(!checked)} active={checked}>
    <ToggleThumb active={checked} />
  </ToggleWrapper>
)

export const Section = ({
  title,
  children,
  defaultOpen = false,
  status = 'idle',
}: {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  status?: SaveStatus
}) => {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <AccordionItem>
      <AccordionHeader onClick={() => setOpen(o => !o)}>
        <span>{title}</span>
        {status !== 'idle' && (
          <SaveIndicator>
            {status === 'saving' ? 'Enregistrement…' : '✓ Enregistré'}
          </SaveIndicator>
        )}
        <Chevron open={open}>▾</Chevron>
      </AccordionHeader>
      {open && <AccordionBody>{children}</AccordionBody>}
    </AccordionItem>
  )
}
